import React from 'react';
import { Link } from 'react-router-dom';
import platformImage from '../assests/main image.png';

const businessNeeds = [
  'Customer communication', 'Notifications', 'Marketing', 'Authentication',
  'Appointment reminders', 'Customer support', 'Order updates', 'Lead follow-ups',
  'Automated workflows',
];
const platformCapabilities = [
  ['Messaging', 'Send supported text and media messages to customers.'],
  ['Templates', 'Create and manage approved WhatsApp message templates.'],
  ['Campaigns', 'Organize and manage customer communication campaigns.'],
  ['Automation', 'Trigger messages based on business events and workflows.'],
  ['CRM', 'Manage customers and leads alongside WhatsApp communication.'],
  ['APIs', 'Connect your applications with WhatsApp messaging.'],
  ['Webhooks', 'Receive supported WhatsApp events and connect them to your systems.'],
];
const messageTypes = ['Text', 'Images', 'Videos', 'Documents', 'Audio', 'Templates'];
const templateUseCases = ['Order confirmations', 'Shipping updates', 'Appointment reminders', 'Authentication', 'Service notifications', 'Marketing communication', 'Customer follow-ups'];
const integrationTargets = ['CRM systems', 'Ecommerce platforms', 'SaaS applications', 'Websites', 'Mobile applications', 'ERP systems', 'Booking platforms', 'Customer support systems', 'Internal business applications', 'Custom software'];
const automationTasks = ['Customer onboarding', 'Welcome communication', 'Appointment reminders', 'Order updates', 'Customer follow-ups', 'Notifications', 'Feedback requests', 'Scheduled campaigns', 'Lead communication'];
const notificationTypes = [
  ['Order Notifications', 'Send order confirmations and status updates.'],
  ['Delivery Updates', 'Notify customers about shipping and delivery events.'],
  ['Appointment Reminders', 'Send appointment confirmations and reminders.'],
  ['Payment Notifications', 'Send permitted payment-related communication.'],
  ['Service Notifications', 'Keep customers informed about important service updates.'],
  ['Account Notifications', 'Communicate important account-related information.'],
];
const marketingCampaigns = ['New product launches', 'Special offers', 'Seasonal promotions', 'New services', 'Events', 'Customer re-engagement', 'Product announcements'];
const crmData = ['Customers', 'Leads', 'Tags', 'Customer status', 'Contact information', 'Appointments', 'Feedback', 'Communication workflows'];
const developerTools = [
  ['Messaging', 'Trigger WhatsApp messages from your application.'],
  ['Templates', 'Use approved templates for supported business-initiated communication.'],
  ['Webhooks', 'Receive supported WhatsApp events and process them in your backend.'],
  ['Automation', 'Trigger communication from application events.'],
  ['CRM Integration', 'Connect customer information with WhatsApp workflows.'],
];
const saasUseCases = ['Customer notifications', 'Authentication', 'Appointment management', 'Transaction updates', 'Customer support', 'Automated reminders', 'Marketing', 'Business alerts'];
const agencyIndustries = ['Ecommerce', 'Real estate', 'Education', 'Hospitality', 'Professional services', 'Retail', 'Service businesses', 'SaaS companies'];
const webhookEvents = ['Incoming messages', 'Message status', 'Delivery updates', 'Read status', 'Other supported events'];
const mediaUseCases = [
  ['Ecommerce', 'Share product-related information.'],
  ['Real Estate', 'Send property-related media.'],
  ['Education', 'Share permitted documents and information.'],
  ['Professional Services', 'Send relevant customer documents.'],
  ['Customer Support', 'Provide useful media as part of customer conversations.'],
];
const industries = [
  ['Ecommerce', 'Automate order confirmations, shipping notifications, delivery updates, and customer communication.'],
  ['Healthcare & Clinics', 'Use permitted appointment communication, reminders, and service notifications in compliance with applicable laws and WhatsApp policies.'],
  ['Education', 'Send permitted announcements, reminders, and student communication.'],
  ['Real Estate', 'Manage leads, follow-ups, and appointment workflows.'],
  ['Hospitality', 'Send booking-related notifications, reminders, and service updates.'],
  ['Financial Services', 'Use permitted customer communication and notifications subject to applicable regulations and WhatsApp policies.'],
  ['SaaS', 'Integrate WhatsApp directly into your software workflows.'],
  ['Agencies', 'Build WhatsApp communication solutions for multiple clients.'],
];
const platformBenefits = [
  ['API Integration', 'Connect WhatsApp with your applications.'],
  ['Automation', 'Create event-driven messaging workflows.'],
  ['Campaigns', 'Manage customer communication campaigns.'],
  ['CRM', 'Organize customers and leads.'],
  ['Templates', 'Manage WhatsApp message templates.'],
  ['Webhooks', 'Connect messaging events with your backend.'],
  ['Media Messaging', 'Work with supported WhatsApp media types.'],
  ['Centralized Platform', 'Manage important WhatsApp communication workflows from one place.'],
];
const setupSteps = [
  ['Connect WhatsApp', 'Set up the WhatsApp Business infrastructure required for your business.'],
  ['Configure HAWKTRION', 'Configure your business and WhatsApp messaging setup.'],
  ['Create Templates', 'Create the message templates required for your business communication.'],
  ['Integrate Your Application', 'Connect your CRM, website, SaaS platform, or custom application.'],
  ['Configure Webhooks', 'Connect supported WhatsApp events to your backend.'],
  ['Build Automation', 'Create automated communication workflows based on business events.'],
  ['Engage Your Customers', 'Use WhatsApp for notifications, campaigns, communication, and support workflows.'],
];
const businessNeedRows = [
  ['Customer Notifications', 'Automated WhatsApp messages'],
  ['Marketing', 'Campaigns and templates'],
  ['Authentication', 'OTP and verification workflows'],
  ['Ecommerce', 'Order and delivery updates'],
  ['Appointments', 'Confirmations and reminders'],
  ['CRM', 'Customer and lead communication'],
  ['SaaS', 'API-based product integration'],
  ['Customer Support', 'WhatsApp conversations'],
  ['Agencies', 'Client communication solutions'],
  ['Automation', 'Event-driven workflows'],
];
const faqs = [
  ['What is WhatsApp API?', 'WhatsApp API enables businesses and developers to connect WhatsApp communication with software applications and business workflows.'],
  ['What can I use WhatsApp API for?', 'Businesses can use WhatsApp API for permitted customer communication, notifications, authentication, marketing, appointment reminders, order updates, customer support, and automation.'],
  ['Can I integrate WhatsApp API with my CRM?', 'Yes. WhatsApp can be connected with CRM systems through APIs and webhook-based integrations.'],
  ['Can developers use WhatsApp API?', 'Yes. Developers can connect websites, SaaS applications, CRM systems, and custom software using APIs and supported webhooks.'],
  ['Can WhatsApp communication be automated?', 'Yes. Applications can trigger supported messages from business events, workflows, or scheduled activities, subject to applicable WhatsApp requirements.'],
  ['Do WhatsApp message templates need approval?', 'Templates used for business-initiated conversations are subject to WhatsApp review, approval, and policy requirements.'],
  ['Can I send marketing messages through WhatsApp?', 'Businesses can send permitted marketing communication when they follow WhatsApp policies, obtain appropriate customer consent, use approved templates where required, and respect opt-out requests.'],
  ['Can WhatsApp API send images and documents?', 'Supported media types include images, videos, documents, and audio. Follow the applicable API requirements and supported formats.'],
  ['Can I receive WhatsApp events in my application?', 'Yes. Supported webhook events can be sent to your backend for processing and integration with business logic.'],
];


const BulletList = ({ items }) => (
  <ul className="business-api-list">
    {items.map((item) => <li key={item}>{item}</li>)}
  </ul>
);

const SectionHeading = ({ eyebrow, title, children }) => (
  <div className="business-api-heading">
    {eyebrow && <div className="sec-label"><span className="sec-label-dot"></span>{eyebrow}</div>}
    <h2>{title}</h2>
    {children && <p>{children}</p>}
  </div>
);

const CardGrid = ({ items }) => (
  <div className="business-api-grid">
    {items.map(([title, description]) => (
      <article className="business-api-card" key={title}>
        <h3>{title}</h3>
        <p>{description}</p>
      </article>
    ))}
  </div>
);

const Workflow = ({ steps }) => (
  <ol className="business-api-workflow">
    {steps.map((step, index) => (
      <li key={step}><span className="business-api-step-number">{index + 1}</span><span>{step}</span></li>
    ))}
  </ol>
);

const WhatsappApiContent = () => (
  <div className="business-api-content">
    <section className="business-api-section business-api-intro">
      <div className="container">
        <div className="business-api-intro-grid">
          <div className="business-api-intro-copy">
            <p className="business-api-lead">Connect WhatsApp with your business applications using HAWKTRION.</p>
            <p>Send customer messages, manage templates, automate notifications, run campaigns, connect your CRM, and integrate WhatsApp communication directly into your business workflows.</p>
            <div className="business-api-actions">
              <Link to="/signup" className="btn btn-p">Get Started</Link>
              <Link to="/whatsapp-api-documentation/" className="btn btn-s">Explore API Documentation</Link>
            </div>
          </div>
          <figure className="business-api-visual">
            <img src={platformImage} alt="HAWKTRION WhatsApp platform showing messaging, CRM, automation, campaigns, and integrations" />
            <figcaption>Connect WhatsApp messaging to the applications and workflows your business already uses.</figcaption>
          </figure>
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Connected Communication" title="Connect WhatsApp With Your Business">
          WhatsApp is an important communication channel for businesses of all sizes, but managing customer communication manually can become difficult as your business grows. HAWKTRION helps connect WhatsApp with your applications and workflows through API-based integration.
        </SectionHeading>
        <h3 className="business-api-subheading">Use WhatsApp for</h3>
        <BulletList items={businessNeeds} />
        <p className="business-api-copy">Turn WhatsApp into a connected part of your business infrastructure.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="The Platform" title="What Is WhatsApp API?">
          WhatsApp API allows businesses and developers to connect WhatsApp communication with software applications and business systems. Instead of manually sending every message, your application can trigger supported WhatsApp communication based on business events and customer actions.
        </SectionHeading>
        <h3 className="business-api-subheading">Example: Order Update</h3>
        <Workflow steps={['Customer places order', 'Your application', 'HAWKTRION API', 'WhatsApp', 'Customer receives update']} />
        <p className="business-api-copy">This allows businesses to create automated and scalable communication workflows.</p>
        <div className="business-api-example">
          <div className="business-api-example-event">
            <span className="business-api-example-label">BUSINESS EVENT</span>
            <strong>order.created</strong>
            <p>Order #4821 is ready for an update.</p>
          </div>
          <div className="business-api-example-arrow" aria-hidden="true">→</div>
          <div className="business-api-example-chat">
            <div className="business-api-example-chat-head">
              <span className="business-api-chat-avatar">H</span>
              <span><strong>HAWKTRION Store</strong><small>WhatsApp Business</small></span>
              <span className="business-api-chat-status">Delivered</span>
            </div>
            <p className="business-api-chat-bubble">Thanks for your order! We&apos;re preparing it now and will send another update when it ships.</p>
            <p className="business-api-chat-meta">Example message · just now</p>
          </div>
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Platform Capabilities" title="One Platform for Your WhatsApp Communication">
          HAWKTRION brings messaging, automation, campaigns, and customer management together in one platform.
        </SectionHeading>
        <CardGrid items={platformCapabilities} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Messaging" title="WhatsApp API Features" />
        <div className="business-api-feature-grid">
          <article className="business-api-card">
            <h3>Send WhatsApp Messages</h3>
            <p>Create messaging workflows for your business applications. Depending on supported API functionality, you can work with:</p>
            <BulletList items={messageTypes} />
            <p>Build communication workflows around your business needs.</p>
          </article>
          <article className="business-api-card">
            <h3>WhatsApp Message Templates</h3>
            <p>Templates are an important part of WhatsApp business communication. Create and manage templates for common use cases:</p>
            <div className="business-api-event-list">
              {templateUseCases.map((useCase) => <p key={useCase}><strong>{useCase}</strong></p>)}
            </div>
            <p>Templates for business-initiated conversations are subject to WhatsApp approval and policy requirements.</p>
          </article>
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Integration" title="Connect WhatsApp to Your Existing Systems">
          Your business may already use CRM, ecommerce, ERP, booking, or customer-management software. Connect those systems with WhatsApp through API-based workflows.
        </SectionHeading>
        <h3 className="business-api-subheading">Integrate With</h3>
        <BulletList items={integrationTargets} />
        <h3 className="business-api-subheading">Integration Example</h3>
        <Workflow steps={['Your application', 'HAWKTRION API', 'WhatsApp', 'Customer']} />
        <p className="business-api-copy">Your application controls the business logic while HAWKTRION manages the WhatsApp communication workflow.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Customer Updates" title="WhatsApp API for Customer Notifications" />
        <CardGrid items={notificationTypes} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Automation" title="Automate Repetitive Customer Communication">
          Your team shouldn&apos;t need to manually send the same messages repeatedly. HAWKTRION helps businesses create automated WhatsApp workflows.
        </SectionHeading>
        <BulletList items={automationTasks} />
        <h3 className="business-api-subheading">Automated Workflow</h3>
        <Workflow steps={['Business event', 'Your application', 'HAWKTRION', 'WhatsApp', 'Customer']} />
        <p className="business-api-copy">Create consistent customer communication while reducing manual work.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Marketing" title="Reach Customers Through WhatsApp">
          Use WhatsApp as part of your customer engagement and marketing strategy.
        </SectionHeading>
        <BulletList items={marketingCampaigns} />
        <h3 className="business-api-subheading">Campaign Workflow</h3>
        <Workflow steps={['Customer database', 'Audience selection', 'Campaign', 'Approved template', 'WhatsApp', 'Customer']} />
        <p className="business-api-copy">Use appropriate customer consent and comply with applicable WhatsApp messaging policies when sending marketing communication.</p>
        <Link to="/whatsapp-marketing/" className="business-api-text-link">Explore WhatsApp Marketing</Link>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Customer Management" title="Connect Customer Data With Communication">
          Customer messaging becomes more useful when your team can access customer information alongside communication workflows. HAWKTRION provides CRM-oriented capabilities for managing:
        </SectionHeading>
        <BulletList items={crmData} />
        <h3 className="business-api-subheading">Build Complete Customer Journeys</h3>
        <Workflow steps={['New lead', 'WhatsApp follow-up', 'Lead qualification', 'Appointment', 'Customer', 'Follow-up', 'Feedback']} />
        <p className="business-api-copy">Keep customer communication organized from lead generation to retention.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="For Developers" title="Build Custom WhatsApp Integrations">
          Developers can integrate WhatsApp communication into websites, SaaS applications, CRM systems, and custom software. Use APIs and webhooks to build these workflows:
        </SectionHeading>
        <CardGrid items={developerTools} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="For SaaS Platforms" title="Add WhatsApp Communication to Your SaaS Product">
          If you operate a SaaS platform, WhatsApp can become part of your product&apos;s communication layer.
        </SectionHeading>
        <BulletList items={saasUseCases} />
        <h3 className="business-api-subheading">SaaS Integration</h3>
        <Workflow steps={['SaaS application', 'HAWKTRION API', 'WhatsApp', 'Your customer']} />
        <p className="business-api-copy">Build WhatsApp directly into your SaaS experience.</p>
        <Link to="/whatsapp-api-for-saas/" className="business-api-text-link">Build WhatsApp Into Your SaaS</Link>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="For Agencies" title="Build WhatsApp Solutions for Your Clients">
          Digital agencies can use HAWKTRION to create WhatsApp communication solutions for their clients.
        </SectionHeading>
        <BulletList items={agencyIndustries} />
        <p className="business-api-copy">Develop reusable WhatsApp solutions and customize them according to each client&apos;s requirements.</p>
        <Link to="/whatsapp-api-for-agencies/" className="business-api-text-link">Build Client WhatsApp Solutions</Link>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Webhooks" title="Connect WhatsApp Events With Your Application">
          Webhooks allow your application to receive supported WhatsApp events and process them automatically.
        </SectionHeading>
        <BulletList items={webhookEvents} />
        <h3 className="business-api-subheading">Event Flow</h3>
        <Workflow steps={['WhatsApp event', 'Webhook', 'HAWKTRION', 'Your application', 'Business logic']} />
        <p className="business-api-copy">Build responsive and event-driven WhatsApp applications.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Rich Communication" title="WhatsApp API Media Messaging">
          Modern customer communication often requires images, documents, videos, and audio. Build workflows around supported WhatsApp media types.
        </SectionHeading>
        <CardGrid items={mediaUseCases} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Across Industries" title="WhatsApp API Use Cases" />
        <CardGrid items={industries} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Why HAWKTRION" title="WhatsApp Messaging Built Around Your Business">
          HAWKTRION provides tools to connect WhatsApp with your existing processes.
        </SectionHeading>
        <CardGrid items={platformBenefits} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Getting Started" title="How WhatsApp API Works" />
        <ol className="business-api-steps">
          {setupSteps.map(([title, description], index) => (
            <li className="business-api-step" key={title}>
              <span className="business-api-step-number">{index + 1}</span>
              <div><h3>{title}</h3><p>{description}</p></div>
            </li>
          ))}
        </ol>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Business Requirements" title="WhatsApp API for Different Business Needs" />
        <div className="cloud-api-table-wrap">
          <table className="cloud-api-table">
            <caption>Examples of business needs and API communication workflows</caption>
            <thead><tr><th scope="col">Business Need</th><th scope="col">WhatsApp API Solution</th></tr></thead>
            <tbody>{businessNeedRows.map(([need, solution]) => <tr key={need}><th scope="row">{need}</th><td>{solution}</td></tr>)}</tbody>
          </table>
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Infrastructure" title="Build Your WhatsApp Communication Infrastructure">
          WhatsApp can be more than a messaging channel. Connect your CRM, website, SaaS, ecommerce, and business applications through API-based communication workflows.
        </SectionHeading>
        <p className="business-api-copy">HAWKTRION helps businesses create connected messaging infrastructure for customer communication, automation, campaigns, and integrations.</p>
      </div>
    </section>

    <section className="business-api-section business-api-faq" id="whatsapp-api-faq">
      <div className="container">
        <SectionHeading eyebrow="Answers" title="WhatsApp API FAQs" />
        <div className="business-api-faq-list">
          {faqs.map(([question, answer]) => <details key={question}><summary>{question}</summary><p>{answer}</p></details>)}
        </div>
      </div>
    </section>

    <section className="business-api-section business-api-final-cta">
      <div className="container">
        <div className="business-api-cta-panel">
          <SectionHeading eyebrow="Get Started" title="Build Your WhatsApp Communication Workflow">
            Connect your applications, automate customer communication, manage campaigns, and bring WhatsApp into your business processes with HAWKTRION.
          </SectionHeading>
          <div className="business-api-actions">
            <Link to="/signup" className="btn btn-p">Get Started With HAWKTRION</Link>
            <Link to="/whatsapp-api-documentation/" className="btn btn-s">View API Documentation</Link>
          </div>
        </div>
       
      </div>
    </section>
  </div>
);

export default WhatsappApiContent;